import { SlidersHorizontal } from "lucide-react";
import { cn } from "@/lib/cn";

export interface FilterOption {
  value: string;
  label: string;
}

interface FiltersProps {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  testId?: string;
}

export const Filters = ({
  label,
  options,
  value,
  onChange,
  className,
  testId = "filters",
}: FiltersProps) => (
  <div className={cn("flex items-center gap-2", className)} data-testid={testId}>
    <SlidersHorizontal className="h-4 w-4 text-muted-foreground" />
    <label className="ops-label hidden sm:block" htmlFor={`${testId}-select`}>
      {label}
    </label>
    <select
      id={`${testId}-select`}
      data-testid={`${testId}-select`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="ops-focus h-9 rounded-sm border border-input bg-card px-2.5 text-sm text-foreground transition-colors duration-150 hover:border-ring/60"
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);
